module.exports = __webpack_public_path__ + "img/background-blue.afff6622.png";